import { RuleId, staticAltTextRule } from '@wix/a11y-rules';
export const prepareChangedAltData = (images, modifiedImageIds, originalPropsMap) => {
  return images.filter(img => modifiedImageIds.has(img.id)).map(img => {
    const originalProps = originalPropsMap.get(img.id);
    return {
      alt: img.altText ?? '',
      breakpointId: img.breakpointId,
      builderLabel: img.builderLabel,
      componentId: img.componentId,
      entityId: img.entityId,
      id: img.id,
      isDecorative: img.isDecorative,
      isLinked: img.isLinked,
      status: img.status,
      tpaData: originalProps == null ? void 0 : originalProps.tpaData
    };
  });
};
export const splitByPageType = (changedAltData, pagesData) => {
  const staticChangedAltData = changedAltData.filter(altData => pagesData.get(altData.entityId ?? '') !== undefined);
  const verticalChangedAltData = changedAltData.filter(altData => pagesData.get(altData.entityId ?? '') === undefined);
  return {
    staticChangedAltData,
    verticalChangedAltData
  };
};
/**
 * Builds a map of component IDs to their alt text data for global section updates.
 */
export const buildGlobalSectionInputMap = changedAltData => {
  return new Map(changedAltData.map(altData => {
    var _altData$tpaData;
    const componentId = ((_altData$tpaData = altData.tpaData) == null ? void 0 : _altData$tpaData.componentId) ?? altData.componentId ?? altData.id;
    return [componentId, {
      alt: altData.alt,
      componentId,
      isDecorative: altData.isDecorative
    }];
  }));
};
export const prepareImagesForChecker = images => {
  return images.map(img => ({
    alt: img.altText ?? '',
    breakpointId: img.breakpointId,
    builderLabel: img.builderLabel,
    componentId: img.componentId,
    decorative: img.isDecorative,
    id: img.id,
    isLinked: img.isLinked,
    uri: img.url
  }));
};
export const calculateStatusAfterApply = (images, tools) => {
  const altToChecker = prepareImagesForChecker(images);
  const {
    status
  } = staticAltTextRule.checker({
    images: altToChecker
  }, tools);
  return status;
};
export const patchScanResultsAfterApply = _ref => {
  let {
    changedAltData,
    pageId,
    getGroupData,
    setGroupExecutionResults,
    tools
  } = _ref;
  const imagesByPageId = new Map();
  for (const img of changedAltData) {
    const key = img.entityId ?? pageId;
    const list = imagesByPageId.get(key) ?? [];
    list.push(img);
    imagesByPageId.set(key, list);
  }
  for (const [affectedPageId, modifiedImages] of imagesByPageId) {
    const groupData = getGroupData(affectedPageId);
    if (!(groupData != null && groupData.ruleExecutionResults)) {
      continue;
    }
    const modifiedById = new Map(modifiedImages.map(img => [img.id, img]));
    const updatedResults = groupData.ruleExecutionResults.map(result => {
      var _result$context;
      if (result.ruleId !== RuleId.STATIC_ALT_TEXT) {
        return result;
      }
      const images = (_result$context = result.context) == null ? void 0 : _result$context.images;
      if (!Array.isArray(images)) {
        return result;
      }
      const updatedImages = images.map(image => {
        const modified = modifiedById.get(image.id);
        if (!modified) {
          return image;
        }
        const passesAsDecorative = !!modified.isDecorative && !modified.isLinked;
        return {
          ...image,
          alt: passesAsDecorative ? '' : modified.alt ?? '',
          decorative: passesAsDecorative
        };
      });
      const {
        failedElements,
        status
      } = staticAltTextRule.checker({
        images: updatedImages
      }, tools);
      return {
        ...result,
        context: {
          ...result.context,
          images: updatedImages
        },
        result: {
          ...result.result,
          failedElements,
          status
        }
      };
    });
    setGroupExecutionResults(affectedPageId, updatedResults);
  }
};
//# sourceMappingURL=prepare-alt-data.js.map